import api, { callRefreshToken } from "../config/http-common";

export const getCompanySetting = async () => {
  const value = await callRefreshToken();
  if (value == true)
    return await api.securedAxiosApi().get("/company/setting" );
};

export const updateBudgetType = async (data) => {
  const value = await callRefreshToken();
  if (value == true)
    return await api.securedAxiosApi().post("/company/setting",data );
};